import "./page.css"

import EventEmitter from "eventemitter3";
import { Data } from "../../models/data";
import { Context } from "../../models/context";
import { LocalizationService } from "../../services/localization-service";
import { EventTypes } from "../../core/event-bus";
import { Pages } from "../../types/enums";
import { Util } from "../../utils/util";

export abstract class Page {
    protected _id: string;
    protected _element: HTMLElement | null;
    protected _eventBus: EventEmitter;
    protected _data: Data;
    protected _context: Context;
    protected _localizationService: LocalizationService;

    constructor(id: string, eventBus: EventEmitter, data: Data, context: Context, localizationService: LocalizationService) {
        this._id = id;
        this._element = null;
        this._eventBus = eventBus;
        this._data = data;
        this._context = context;
        this._localizationService = localizationService;
    }

    public init(): void {
        this._element = document.getElementById(this._id);
        this.hide();
    }

    public abstract initAsync(): Promise<void>;

    public show(): void {
        if (this._element) {
            this._element.classList.toggle("open", true);
        }
    }

    public hide(): void {
        if (this._element) {
            this._element.classList.toggle("open", false);
        }
    }

    // Shared logout redirect: Menu if a store is selected, else Landing -- or Setting 274's
    // external URL if configured (home wins over locator when both are set). External URLs are website only.
    protected _redirectAfterLogout(): void {
        if (this._data.storeKey) {
            this._eventBus.emit(EventTypes.LOCATION_CHANGE, Pages.MENU);
            return;
        }

        if (Util.isAppView()) {
            this._eventBus.emit(EventTypes.LOCATION_CHANGE, Pages.LANDING);
            return;
        }

        const settings = this._data.getBrandProperty("Settings")?.OOS;
        const homepageRedirectUrl = settings?.homepageRedirectUrl;
        const storeLocatorRedirectUrl = settings?.storeLocatorRedirectUrl;

        if (homepageRedirectUrl && storeLocatorRedirectUrl) {
            Util.redirect(homepageRedirectUrl);
        } else if (storeLocatorRedirectUrl) {
            Util.redirect(storeLocatorRedirectUrl);
        } else {
            this._eventBus.emit(EventTypes.LOCATION_CHANGE, Pages.LANDING);
        }
    }
}